import type { UiPaymentStatus } from '@models/payments';
import { UiPaymentStatuses } from '@models/payments';
import { PAYMENT_STATUS_LABELS } from '@features/payments/constants';

import s from './PaymentStatusBadge.module.css';

const STATUS_CLASSES: Record<UiPaymentStatus, string> = {
  [UiPaymentStatuses.SUCCEEDED]: s.succeeded,
  [UiPaymentStatuses.PENDING]: s.pending,
  [UiPaymentStatuses.FAILED]: s.failed,
  [UiPaymentStatuses.REFUNDED]: s.refunded,
  [UiPaymentStatuses.PARTIALLY_REFUNDED]: s.partiallyRefunded,
};

type PaymentStatusBadgeProps = {
  status: UiPaymentStatus;
};

function PaymentStatusBadge({ status }: PaymentStatusBadgeProps) {
  return (
    <span className={`${s.status} ${STATUS_CLASSES[status]}`}>
      <span className={s.statusDot} />
      <span className={s.statusLabel}>{PAYMENT_STATUS_LABELS[status]}</span>
    </span>
  );
}

export default PaymentStatusBadge;
